<template>
  <div class="draftCampaign">
    <div class="draftCampaign__title">
      <div class="draftCampaign__title__main"><h1 class="medium-title">Campaign Draft</h1></div>
      <div class="draftCampaign__title__sub"><span class="subhead">All Unpublished campaign</span></div>
    </div>
    <div class="draftCampaign__header">
      <div class="draftCampaign__header__left">
        <div class="draftCampaign__header__left__search">
          <i class="adx-ic_search"></i>
          <input v-model="searchBoxValue" type="text" placeholder="Search campaign channel">
        </div>
        <adx-dropdown-list class="mediatype" @selected="selectedChannel" :valueDisplay="selectedChannelValue" :list="channelOptions" :labelButton="`All Channels`" :color="`pink`"/>
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset</button>
        </div>
      </div>
       <div class="draftCampaign__header__right">
        <div class="draftCampaign__header__right__sort">
          <div class="draftCampaign__header__right__sort__label">Sort by:</div>
          <a-dropdown-sort class="draftCampaign__header__right__sort__dropdown" :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="draftCampaign__listing">
      <div class="body">
        <div class="body__left">
          <div v-if="isLoading" class="table__loadingWrapper">
            <slot name="loading" />
            <adx-loading/>
          </div>
          <div v-else-if ="campaignList.length > 0"  class="body__left__container">
            <div v-for="(item, index) in campaignList" :key="index + '_item'"  class="body__left__container__item">
              <div class="campaign-item">
                <div class="campaign-item__wrapper">
                  <div class="campaign-item__wrapper__left">
                    <div class="campaign-item__wrapper__left__check-box">
                      <span :class="['selection-checkbox', model.selectedCampaign.includes(item.id) ? 'checked' : '']" 
                        @click.stop="toggleSelectCampaign(item)"><i class="icon-check"></i></span>
                      <adx-label-custom v-if="item.channel_name=='airlines'" :color="'#b620e0'" :label="'AIRLINES'"/>
                      <adx-label-custom v-else-if="item.channel_name=='outdoor'" :color="'#47d1af'" :label="'OUTDOOR'"/>
                      <adx-label-custom v-else-if="item.channel_name=='lifestyle'" :color="'#5856d6'" :label="'LIFESTYLE'"/>
                      <adx-label-custom v-else-if="item.channel_name=='bus'" :color="'#fa6400'" :label="'BUS ADVERTISING'"/>
                    </div>
                    <span class="item-name regular-font strong">{{item.name}}</span>
                    <span class="item-location color-grey subhead"> Date {{displayPeriod(item.start, item.end)}} • {{item.count}} Item
                    </span>
                  </div>
                  <div class="campaign-item__wrapper__right">
                    <div class="campaign-item__wrapper__right__price">
                      <span class="mini-font color-grey">Campaign Price</span>
                      <span class="subhead total-price color-pink strong">{{getPriceWithPPn(item.total_price) | formatMoney}}</span>
                    </div>
                  </div>
                </div>
                <div class="campaign-item__bottom">
                  <button type="button" class="secondary btn-small duplicate" 
                    @click.stop="duplicateCampaign(item.id)">Duplicate</button>
                  <button type="button" class="secondary btn-small delete" 
                    @click.stop="confirmDelete(item.id)">Delete</button>
                  <button type="button" class="secondary btn-small edit" 
                    @click.stop="goToEditor(item.id)">Edit</button>
                </div>
              </div>
            </div>
              <template v-if="!isSubLoading && campaignList.length > 0">
                <div v-if="next" class="body__left__container__paging" @click.stop="loadInfiniteData">
                  <button class="btn-regular secondary"> <strong>Load More</strong> </button>
                </div>
                <div v-else class="body__left__container__paging">
                  <span class="body__left__container__paging__empty"> There is no more data </span>
                </div>
              </template>
              <template  v-else>
                <div class="body__left__container__load-more">
                  <adx-loading v-if="isSubLoading"/>
                </div>
              </template>
          </div>
          <div class="emptyState">
             <adx-empty-selection v-if="isEmpty && !isLoading" :title="title"/>
          </div>
        </div>
        <div class="body__right">
          <div class="body__right__container">
            <h1 class="subhead title">Summary</h1>
            <div class="body__right__container__item">
              <span class="subhead"> Selected Campaign </span>
              <span class="subhead"> {{ model.selectedCampaign.length ? model.selectedCampaign.length : '-' }} </span>
            </div>
            <div class="body__right__container__item">
              <span class="subhead"> Campaign Start</span>
              <span class="subhead"> {{model.startDate ? displayPeriod(model.startDate) : '-'}} </span>
            </div>
            <div class="body__right__container__item">
              <span class="subhead"> Campaign End</span>
              <span class="subhead"> {{model.endDate ? displayPeriod(model.endDate) : '-'}} </span>
            </div>
          </div>
          <div class="body__right__container">
            <div class="body__right__container__item">
              <span class="subhead">Total Price </span>
              <span class="price color-pink strong"> {{getPriceWithPPn(model.totalCampaignPrice) | formatMoney}}</span>
            </div>
          </div>
          <div class="body__right__button__top">
          <button class="btn-regular primary" :class="[isLoadingQuotation? 'disabled': '']" @click="createQuotation()" :disabled="isLoadingQuotation">Continue
            <adx-loading-secondary-white v-if="isLoadingQuotation"/>
          </button>
          </div>
        </div>
      </div>
    </div>
    <adx-modal hideClose="true" v-if="isShowModal" title="Delete Campaign" type="small">
      <div slot="content" class="draftCampaign__modal">
        <div class="draftCampaign__modal__top">
          <span>Sure want to delete this campaign?</span>
        </div>
        <div class="draftCampaign__modal__bottom">
          <button class="btn-regular primary" @click="deletecampaign()">Yes</button>
          <button class="btn-regular secondary" @click="cancelDelete()">Cancel</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal hideClose="true" v-if="isQuotationCreated" type="small">
      <div slot="content" class="draftCampaign__modal-2">
        <div class="draftCampaign__modal-2__top">
          <img class="icon-img" :src="iconImg" alt="">
          <h1 class="title bold medium-title">Quotation Submitted</h1>
          <span class="sub-title subhead">Hang on, Your quotation has been sent to Grace team for review. :)</span>
        </div>
        <div class="draftCampaign__modal-2__bottom">
          <button class="btn-block primary" @click="goQuotationList()">View My Qoutation</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import LoadingSecondaryWhite from '@/components/Loading/Secondary-white'
import api from '@/api'
import { AEmptySelection, ALoadingPrimary, ALoadingSecondaryWhite, APagination, AMenuExpansion, ALoadingSecondary,
         AModal, AListDropdown, ASelectDropdown, AMultipleCheckbox, AStatusLabelCustom} from "ui-kit-v1"

import { mapGetters } from 'vuex'
import { restEdge } from '@/api/edgeUrls'
import { mapListFilter } from '@/lib/transformer'
import { globalMixins } from "@/lib/mixins/globalMixins"

import * as validationLib from '@/lib/validation/'
import lib from '@/lib/util'
const { helpers, } = validationLib;

export default {
  name: 'adx-campaign-draft',
  components: {
    'adx-modal': AModal,
    'adx-empty-selection': AEmptySelection,
    'adx-loading': ALoadingPrimary,
    'adx-loading-2': ALoadingSecondary,
    'adx-loading-white': ALoadingSecondaryWhite,
    'adx-loading-secondary-white': LoadingSecondaryWhite,
    'adx-pagination': APagination,
    'menu-expansion': AMenuExpansion,
    'adx-dropdown-list': AListDropdown,
    'a-dropdown-sort': ASelectDropdown,
    'adx-multiple-checkbox': AMultipleCheckbox,
    'adx-label-custom': AStatusLabelCustom,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      count: 0,
      model: {
        selectedCampaign: [],
        totalCampaignPrice: 0,
        startDate: null,
        endDate: null,
        owner: null,
      },
      next: null,
      isFromInfinite: false,
      isSubLoading: false,
      isLoadingQuotation: false,
      listStartDate: [],
      listEndDate: [],
      isEmpty: false,
      iconImg: "/img/icon-checklist.png",
      isLoadingMain:false,
      isShowModal: false,
      isQuotationCreated: false,
      maxPage: 1,
      searchBoxValue: null,
      selectedCampaignId: null,
      selectedPage: 1,
      selectedSortValue: "-created",
      selectedChannelValue: null,
      selectedChannelLabel: null,
      title: "You dont have any campaign here. lets create some !",
      campaignList: [],
      sortOptions: [
        {
          label: "Last Added",
          value: "-created",
        },
        {
          label: "First Added",
          value: "created",
        },
        {
          label: "Highest Price",
          value: "-total_price",
        },
        {
          label: "Lowest Price",
          value: "total_price",
        },
        {
          label: "Name",
          value: "name",
        }
      ],
      channelOptions: [
        {
          id: 1,
          label: "Airlines",
          value: "airlines"
        },
        {
          id: 2,
          label: "Outdoors",
          value: "outdoor"
        },
        {
          id: 3,
          label: "Lifestyle",
          value: "lifestyle"
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      user: 'account',
    }),
    isLoading: function(){
      return this.isLoadingMain || false
    },
    getQueryParams(){
      let queryParams = {
        search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
      }
      return queryParams
    },
    filtered: function() {
      let filtered = false
      if (this.selectedChannelValue){
        filtered = true
      }
      return filtered
    },
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.selectedPage = 1
      this.count = 0
      this.loadData(false)
    }, 500),
    selectedSortValue: function () {
      this.count = 0
      this.selectedPage = 1
      this.loadData(false)
    },
    selectedChannelValue: function() {
      this.$nextTick(() => {
        this.loadData(false)
      })
    },
    selectedPeriodValue: function() {
      this.$nextTick(() => {
        this.loadData();
      });
    }
  },
  beforeCreate() {

  },
  created() {
    this.loadData();
    let localData = this.getFromLocal()
    this.model = localData.model
    this.listStartDate = localData.dates.listStartDate
    this.listEndDate = localData.dates.listEndDate
    this.model.owner = this.user.userId
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {
    this.clearLocalData()
  },
  methods: { 
    getFromLocal() {
      let savedData = localStorage.getItem('selectedCampaignDraft')
      if (!savedData) {
        savedData = JSON.stringify({
          model: {
            selectedCampaign: [],
            totalCampaignPrice: 0,
            startDate: null,
            endDate: null,
          },
          dates: {
            listStartDate: [],
            listEndDate: []
          }
        })
      }
      return JSON.parse(savedData)
    },
    saveToLocal(data = null){
      let localData = {
        model: {...this.model},
        dates: {
          listStartDate: this.listStartDate,
          listEndDate: (this.listEndDate)
        }
      }
      localStorage.setItem('selectedCampaignDraft', JSON.stringify(localData))
    },
    resetFilter() {
      this.selectedChannelValue = null
      // this.selectedPeriodValue = []
      this.selectedPage = 1
      this.loadData()
    },
    async loadData(isFromInfinite = false){
      if(!isFromInfinite) this.campaignList = []
      isFromInfinite ? this.isSubLoading = true : this.isLoadingMain = true
    
      const params = {          
        ...this.getQueryParams, 
        sort_by: this.selectedSortValue,
        page: this.selectedPage,
        channel: this.selectedChannelValue
      };
      const response = await api.get(restEdge.draftCampaignChannel, { 
        needToken: true, 
        useRestEdge: true, 
        params : params
      });
      
      if(response.status == 200){
        const {data} = response
        this.count = response.data.count
        this.next = data.next ? data.next : false
        if (isFromInfinite) {
          this.$data.campaignList = this.$data.campaignList.concat(data.results)
        } else {
          this.$data.campaignList = data.results
          this.isEmpty = this.campaignList.length === 0
        }
        this.$data.isSubLoading = false
        this.isLoadingMain = false
      } else {
        this.showNotificationAlert("Error", "Data failed to load!", "danger")
        this.isLoadingMain = false
        this.isEmpty = true
      }
    },
    async loadInfiniteData() {
      if (this.$data.next) {
        this.$data.isSubLoading = true
        this.$data.selectedPage += 1
        this.loadData(true)
      }
    },
    getPriceWithPPn(price){
      return price? price + (0.1 * price): 0
    },
    toggleSelectCampaign(campaign){
      if (this.model.selectedCampaign.includes(campaign.id)) {
        // pop id when user unselected campaign item
        let index = this.model.selectedCampaign.indexOf(campaign.id)
        this.model.selectedCampaign.splice(index, 1)

        // pop start date when user unselected campaign item
        let minDate = this.listStartDate.indexOf(campaign.start)
        this.listStartDate.splice(minDate, 1)

        // pop end date when user unselected campaign item
        let maxDate = this.listEndDate.indexOf(campaign.end)
        this.listEndDate.splice(maxDate, 1)

        //calculating campaign price
        this.model.totalCampaignPrice -= campaign.total_price
      } else {
        this.model.selectedCampaign.push(campaign.id)
        this.model.totalCampaignPrice += campaign.total_price
        this.listStartDate.push(campaign.start)
        this.listEndDate.push(campaign.end)
      }

      // get min date for start date
      if(this.listStartDate.length > 0){
        this.model.startDate = new Date(Math.min.apply(null, this.listStartDate.map(el => {
            return new Date(el);
          })
        ));
      } else {
        this.model.startDate = null
      }

      //get max date for end date
      if(this.listEndDate.length > 0){
        this.model.endDate = new Date(Math.max.apply(null, this.listEndDate.map(el => {
            return new Date(el);
          })
        ));
      } else{
        this.model.endDate = null
      }

      this.saveToLocal()
    },
    async createQuotation(){
      this.isLoadingQuotation = true
      if(this.model.selectedCampaign.length > 0) {
        let body = {
          name: 'Untitled',
          total_price: Math.round(this.model.totalCampaignPrice),
          campaigns_id : this.model.selectedCampaign,
          owner: this.model.owner
        }
        const {data, status} = await api.post(restEdge.createQuotation, body, { needToken: true, useRestEdge: true })

        if (status == 200){
            // this.isQuotationCreated = true
            this.clearLocalData()
            this.$router.push({ name: 'quotationeditor', params: {id: data.id} });
        } else{
            this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
        }
      } else {
        this.showNotificationAlert('Error', 'No campaign is selected', 'danger')
      }
      this.isLoadingQuotation = false
    },
    async duplicateCampaign(id){
      this.isLoadingMain = true;
      const response = await api.post(restEdge.duplicateDraftCampaignChannel(id), {}, { needToken: true, useRestEdge: true,});
      if(response.status == 200) {
        this.isLoadingMain = true;
        this.loadData(false);
        this.isLoadingMain = false;
        this.showNotificationAlert('Success', 'Campaign successfully duplicated!', 'success')
      } else {
        this.isLoadingMain = true;
        this.loadData(false);
        this.isLoadingMain = false;
        this.showNotificationAlert('Error', 'Campaign failed to duplicated!', 'danger')
      }
    
    },
    async deletecampaign() {
      this.isLoadingMain = true;
      const response = await api.destroy(restEdge.deleteDraftCampaignChannel(this.selectedCampaignId), { needToken: true, useRestEdge: true,});
      
      if(response.status == 200) {
        this.toggleModal();
        this.loadData();
        this.isLoadingMain = false;
        this.showNotificationAlert('Success', 'Campaign successfully deleted!', 'success')
      } else {
        this.toggleModal();
        this.loadData();
        this.isLoadingMain = false;
        this.showNotificationAlert('Error', 'Campaign failed to delete!', 'danger')
      }
    },
    confirmDelete(id){
      this.selectedCampaignId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedCampaignId = null;
      this.toggleModal()
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    selectedChannel(item){
      this.selectedChannelValue = item.value
      this.selectedChannelLabel = item.label
    },
    goQuotationList() {
      this.$router.push({ name: 'quotationlist'})
    },
    goToEditor(id){
      this.$router.push({ name: 'campaigneditoredit', params: {id: id} });
    },
    displayPeriod(startDate, endDate) {
      if(startDate && endDate ){
        return `${lib.formatShortDate(startDate)} - ${lib.formatShortDate(endDate)}`
      } else{
        return `${lib.formatShortDate(startDate)}`
      }
    },
    clearLocalData() {
      let localData = {
        model: {
          selectedCampaign: [],
          totalCampaignPrice: 0,
          startDate: null,
          endDate: null,
          owner: null
        },
        dates: {
          listStartDate: [],
          listEndDate: []
        }
      }
      localStorage.setItem('selectedCampaignDraft', JSON.stringify(localData))
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
